package com.gsb.vyapar.bhagya.presentation.navigation.view

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Card
import androidx.compose.material.ExperimentalMaterialApi
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.domain.getAbout
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.image.SocialPlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.image.StorePlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularB
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularBBStart
import com.gsb.vyapar.bhagya.presentation.common.text.Text18SemiBold
import com.gsb.vyapar.bhagya.presentation.common.text.Text18SemiBoldI
import com.gsb.vyapar.bhagya.theme.applestore
import com.gsb.vyapar.bhagya.theme.black
import com.gsb.vyapar.bhagya.theme.facebook
import com.gsb.vyapar.bhagya.theme.googlestore
import com.gsb.vyapar.bhagya.theme.instagram
import com.gsb.vyapar.bhagya.theme.mail
import com.gsb.vyapar.bhagya.theme.offwhite
import com.gsb.vyapar.bhagya.theme.splash
import com.gsb.vyapar.bhagya.theme.twitter
import com.gsb.vyapar.bhagya.theme.web
import com.gsb.vyapar.bhagya.theme.webstore
import com.gsb.vyapar.bhagya.theme.whatsapp
import com.gsb.vyapar.bhagya.util.BuildConfig
import com.gsb.vyapar.bhagya.util.PlatformType
import com.gsb.vyapar.bhagya.util.getAndroid
import com.gsb.vyapar.bhagya.util.getEmail
import com.gsb.vyapar.bhagya.util.getFb
import com.gsb.vyapar.bhagya.util.getInst
import com.gsb.vyapar.bhagya.util.getIos
import com.gsb.vyapar.bhagya.util.getMobile
import com.gsb.vyapar.bhagya.util.getWebApp
import com.gsb.vyapar.bhagya.util.getWebsite
import com.gsb.vyapar.bhagya.util.getX

@OptIn(ExperimentalMaterialApi::class)
@Composable
fun AboutGSBVyaparBhagyaView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    val uriHandler = LocalUriHandler.current
    Card(
        modifier = Modifier.fillMaxWidth(),
        shape = RoundedCornerShape(8.dp),
        backgroundColor = offwhite,
    ) {
        Column(modifier = Modifier.fillMaxWidth().padding(16.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                CommonImage(splash, 150.dp, 150.dp)
                Text18SemiBoldI("About GSB-VyaparBhagya", black)
            }
            Text14RegularBBStart("${getState().getInfo().getAbout()} gsbvyaparbhagya@gmail.com", black)
            Spacer(Modifier.height(16.dp))
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceEvenly) {
                SocialPlaceHolder(facebook, modifier = Modifier.clickable { uriHandler.openUri(getFb()) })
                SocialPlaceHolder(twitter, modifier = Modifier.clickable { uriHandler.openUri(getX()) })
                SocialPlaceHolder(instagram, modifier = Modifier.clickable { uriHandler.openUri(
                    getInst()
                ) })
                SocialPlaceHolder(mail, modifier = Modifier.clickable { uriHandler.openUri("mailto:${getEmail()}") })
                SocialPlaceHolder(whatsapp, modifier = Modifier.clickable { uriHandler.openUri("https://wa.me/+91${getMobile()}") })
                SocialPlaceHolder(web, modifier = Modifier.clickable { uriHandler.openUri(getWebsite()) })
            }
            if (BuildConfig.platform() != PlatformType.IOS) {
                Spacer(Modifier.height(8.dp))
                Text14RegularB("App is available in PlayStore, AppStore & Web:", black)
                Spacer(Modifier.height(8.dp))
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.Center) {
                    StorePlaceHolder(googlestore, modifier = Modifier.clickable { uriHandler.openUri(
                        getAndroid()
                    ) })
                    Spacer(Modifier.width(10.dp))
                    StorePlaceHolder(applestore, modifier = Modifier.clickable { uriHandler.openUri(
                        getIos()
                    ) })
                    Spacer(Modifier.width(10.dp))
                    StorePlaceHolder(webstore, modifier = Modifier.clickable { uriHandler.openUri(
                        getWebApp()
                    ) })
                }
            }
        }
    }
}